import { Link } from "react-router-dom";
import { FileText, ShieldCheck, MessageCircle, ArrowRight } from "lucide-react";

const heroImg = "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <header className="max-w-6xl mx-auto px-4 sm:px-6 pt-6 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="leading-none">
            <div className="font-heading font-extrabold text-slate-900 text-lg sm:text-xl tracking-tight">Co-Legal</div>
          </div>
        </div>
        <Link to="/login" className="bm-btn-primary text-sm px-4 min-h-[44px]" data-testid="landing-login-btn">
          Entrar <ArrowRight className="w-4 h-4" />
        </Link>
      </header>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-16 sm:pt-24 pb-12 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EDF5F3] text-[#2A5C55] text-xs font-semibold mb-6">
            <ShieldCheck className="w-4 h-4" /> Contratos ajustados a cada caso real
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-extrabold tracking-tight text-slate-900 leading-[1.05]">
            Genera contratos inmobiliarios
            <span className="block text-[#1E3A5F]">sin dolor de cabeza.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
            Cuestionario paso a paso, una pregunta a la vez. Vista previa, descarga en PDF y comparte por WhatsApp. Diseñado para asesores inmobiliarios en México.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to="/login" className="bm-btn-primary" data-testid="landing-cta-primary">
              Comenzar ahora <ArrowRight className="w-4 h-4" />
            </Link>
            <a href="#docs" className="bm-btn-secondary">Ver documentos</a>
          </div>
          <div className="mt-8 flex items-center gap-6 text-xs text-slate-500">
            <div className="flex items-center gap-1.5"><FileText className="w-4 h-4" /> 4 contratos listos</div>
            <div className="flex items-center gap-1.5"><MessageCircle className="w-4 h-4" /> Envío por WhatsApp</div>
            <div className="flex items-center gap-1.5"><ShieldCheck className="w-4 h-4" /> Validación experta</div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-6 bg-gradient-to-br from-[#1E3A5F]/15 via-transparent to-[#2A5C55]/15 blur-3xl -z-10 rounded-[3rem]" />
          <img src={heroImg} alt="Arquitectura mexicana"
               className="rounded-3xl border border-[#E2DCD2] shadow-[0_20px_60px_-20px_rgba(200,90,50,0.35)] w-full aspect-[4/3] object-cover" />
        </div>
      </section>

      <section id="docs" className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
        <h2 className="text-3xl font-heading font-bold text-slate-900 mb-3">4 documentos, todo el flujo de venta</h2>
        <p className="text-slate-600 mb-10">Cada documento hereda datos del anterior. Registras al propietario una sola vez.</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { t: "Comisión Mercantil", d: "Establece la relación con el propietario, exclusividad y comisión.", c: "#1E3A5F" },
            { t: "Carta Oferta", d: "El comprador formaliza su oferta con precio, origen de fondos y esquema de pagos.", c: "#D99B26" },
            { t: "Promesa de Compraventa", d: "Compromiso formal previo a la escritura: precio, arras, notaría y pena.", c: "#2A5C55" },
            { t: "Arrendamiento Habitacional", d: "Formaliza el uso habitacional estableciendo rentas, mantenimiento y garantías.", c: "#8B5A3C" },
          ].map((x) => (
            <div key={x.t} className="bm-card p-6">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ background: `${x.c}18`, color: x.c }}>
                <FileText className="w-5 h-5" />
              </div>
              <h3 className="text-xl font-heading font-bold text-slate-900">{x.t}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      <footer className="border-t border-[#E2DCD2] py-8 mt-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-sm text-slate-500 flex items-center justify-between">
          <div>2026 powered by BROKER-MEXICO.com</div>
          <Link to="/login" className="text-[#1E3A5F] font-semibold">Entrar</Link>
        </div>
      </footer>
    </div>
  );
}
